<script lang="ts" setup>
import moment from 'moment'
import mkrbJobCategory from '~/public/assets/mkrb-category/title.json'
import locales from '~/assets/data/locales.json'
import dateLocale from '~/assets/data/date-localization.json'

const { $config } = useNuxtApp()
const route = useRoute()
const selection = '0abcdefghijklmnopqrstuvwxyz'

if (isEmpty(useGetSubdomain()))
  navigateTo('', { redirectCode: 301 })

updateMeta()
function updateMeta() {
  const country = locales.find(item => item.region === useGetSubdomain())?.label || ''
  const metaTitle = ref(`All Jobs - Urgent Need New Staffs | ${moment().format('MMMM')} ${moment().format('YYYY')} - Epicareer`)
  const metaDesc = ref(`Looking for all jobs in ${country}? The companies here open hiring. Full-Time, Remote, Freelance, Part-Time, Internship Available on Epicareer!`)
  const robotsDefault = ($config.public.ENV === 'development' || $config.public.ENV === 'staging') ? { name: 'robots', content: 'nofollow, noindex' } : { name: 'robots', content: 'index, follow' }

  if (useGetSubdomain() === 'id') {
    const month = dateLocale[0]?.months[parseInt(moment().format('M')) - 1]
    metaTitle.value = `Semua Lowongan - Butuh Karyawan Secepatnya | ${month} ${moment().format('YYYY')} - Epicareer`
    metaDesc.value = `Cari semua pekerjaan di ${country}? Perusahaan-perusahaan ini sedang hiring. Full-Time, Remote, Freelance, Part-Time, Internship Ada di Epicareer!`
  }
  else if (useGetSubdomain() === 'my') {
    const month = dateLocale[1]?.months[parseInt(moment().format('M')) - 1]
    metaTitle.value = `Kerja Kosong - Perlukan Pekerjaan Dengan Segera | ${month} ${moment().format('YYYY')} - Epicareer`
    metaDesc.value = `Sedang mencari kerja di ${country}? Syarikat-syarikat ini sedang membuka peluang pekerjaan. Full-Time, Remote, Freelance, Part-Time, Internship semuanya ada di Epicareer!`
  }
  useHead({
    title: metaTitle,
    meta: [
      { property: 'og:title', content: metaTitle },
      { name: 'twitter:title', content: metaTitle },
      { name: 'description', content: metaDesc },
      { property: 'og:description', content: metaDesc },
      { name: 'twitter:description', content: metaDesc },
      robotsDefault,
    ],
    link: [
      { rel: 'canonical', href: useSetSubdomain(useGetSubdomain()) + route.path },
    ],
  })
}
</script>

<template>
  <BaseAtomsSkeletonBounded class="!py-0 !xl:px-0 text-gray-900">
    <!-- JOBS BY COMPANIES -->
    <p class="text-4xl font-bold font-serif pt-6 md:pt-10">
      Jobs by Companies
    </p>
    <div class="p-4 text-xs grid grid-cols-8 sm:grid-cols-12 gap-x-3 gap-y-6 lg:space-x-4 lg:flex items-center break-all">
      <NuxtLink v-for="(item, idx) in selection.split('')" :key="idx" :to="`/jobs/by-company?filter=${item}`" class="uppercase text-[#5843E5] text-sm">
        {{ item === '0' ? '#' : item }}
      </NuxtLink>
    </div>

    <!-- JOBS BY CATEGORY -->
    <p class="text-4xl font-bold font-serif pt-6 md:pt-10">
      Job Category
    </p>
    <div v-if="!isEmpty(mkrbJobCategory)" class="bg-[#F9FAFB] p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      <NuxtLink v-for="(item, idx) in mkrbJobCategory" :key="idx" :to="`/jobs/${item.slug.toLowerCase()}`" class="capitalize text-[#5843E5] text-sm font-semibold">
        {{ item.name }}
      </NuxtLink>
    </div>
    <div v-else class="text-center bg-[#F9FAFB] p-4 md:pb-12">
      <div class="w-76 mx-auto">
        <img class="w-56 h-56 mx-auto" src="/images/career-guide/empty-state.png">
        <p class="text-lg font-bold mb-2">
          No Jobs Category Found
        </p>
        <p class="text-sm text-gray-600">
          Sorry, currently our directory does not contain jobs category for this country
        </p>
      </div>
    </div>
  </BaseAtomsSkeletonBounded>
</template>
